import React, {useContext} from "react";
import {UserContext} from "@context/UserContext";

const ListItemTrailResult = props => {
    const {userName, userResults, completeDate} = props;
    const {user} = useContext(UserContext);
    const resultsHeight = 48,
        lineStart = 24,
        textGap = 4,
        lineWidth = 4;

    return (
        <tr>
            <td className={'ch-table-noWrap padding-y--m padding-r--m'}>
                {userName}
            </td>
            {userResults.length === 0 &&
                <>
                    <td></td>
                    <td className={'padding-y--l'}>No results recorded</td>
                </>
            }
            {userResults.length !== 0 &&
                <>
                    <td>
                        {user.dateTimeFormat.format(completeDate)}
                    </td>
                    <td className={'padding-y--m'} style={{overflow: 'hidden'}}>
                        <div className={'ch-listItem-trailResults'}>
                            <svg height={resultsHeight} style={{overflow: 'visible'}}>
                                <text>
                                    <tspan x={lineStart} y={0} dy={'0.4em'} textAnchor={'end'} >100%</tspan>
                                    <tspan x={lineStart} y={(resultsHeight / 2)} dy={'0.4em'} textAnchor={'end'} >50%</tspan>
                                    <tspan x={lineStart} y={resultsHeight} dy={'0.4em'} textAnchor={'end'} >0%</tspan>
                                </text>
                                <g style={{stroke: 'var(--border-color)'}}>
                                    <line x1={(lineStart + textGap)} y1={0} x2={(lineStart + lineWidth + textGap)} y2={0} />
                                    <line x1={(lineStart + textGap)} y1={(resultsHeight / 2)} x2={(lineStart + lineWidth + textGap)} y2={(resultsHeight / 2)} />
                                    <line x1={(lineStart + textGap)} y1={resultsHeight} x2={(lineStart + lineWidth + textGap)} y2={resultsHeight} />
                                </g>
                            </svg>
                            <div className={'ch-trail-result-marks'} style={{height: resultsHeight}}>
                                {userResults.map((result, index) => {
                                    const score = result.stepHasResult && !result.skipStep ? result.score : 100;
                                    return (
                                        <div key={index + 1} className={'ch-trail-result-mark'}>
                                            <div className={(result.skipStep ? 'ch-trail-result-mark-skipped' : !result.stepHasResult ? 'ch-trail-result-mark-noResult' : 'ch-trail-result-mark-correct')} style={{height: score + '%'}}></div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </td>
                </>
            }
        </tr>
    )
}

export default ListItemTrailResult;